/**
 * Mock quest dashboard content for `/dashboard/quests` (replace with API later).
 */

import { dashboardAsset } from "../utils/dashboardAssets";

/**
 * These images must be clean artwork only. Do not use screenshots of completed UI mockups here.
 * UI text, buttons, stats, and labels are rendered separately in React/CSS.
 *
 * Hero + cards: Treydora dashboard cinematic pack (`public/assets/dashboard/`) — environment/key art.
 * AI visual: chronicle terminal art (same pack). If any edge case still shows baked UI from source art,
 * adjust `imagePosition` / overlays in CSS — TODO: swap to dedicated text-free quest plates when available.
 */
export const QUEST_VISUAL_HERO = dashboardAsset("01_hero_oshar_city_spires.png");

/** Lore / AI atmosphere — official dashboard illustration (no duplicate in-card UI). */
export const QUEST_VISUAL_AI = dashboardAsset("07_ai_chronicle_lore_terminal.png");

export const QUEST_DASHBOARD_PAGE = {
  pageTitle: "Quests of Treydora",
  subtitle:
    "Enter the world before the game begins. Choose your path, complete trials, and build your legend.",
};

export const QUEST_DASHBOARD_FEATURED = {
  key: "ai-storyteller",
  title: "AI Storyteller",
  eyebrow: "Featured",
  description: "A living choose-your-own-adventure guided by AI—pick a path and shape the story.",
  chips: ["Warrior Trial", "Merchant Path", "Explorer Route"],
  cta: "Begin Story",
  /** Cinematic visual only; text lives in React. */
  image: QUEST_VISUAL_AI,
  imagePosition: "52% 42%",
  /** TODO: replace with dedicated hologram plate if chronicle art ever conflicts with layout. */
  fallbackClass: "quest-art-ai-fallback",
};

export const QUEST_DASHBOARD_CARDS = [
  {
    key: "daily-quest",
    number: 1,
    title: "Daily Quest",
    image: dashboardAsset("08_treydoravr_gateway_access.png"),
    imagePosition: "center 28%",
    fallbackClass: "quest-art-daily",
    description: "Today: Complete one mission to keep your streak alive.",
    stats: [
      { label: "Streak", value: "7 Days" },
      { label: "XP Reward", value: "+250 XP", accent: "blue" },
    ],
    cta: "Start Daily Quest",
  },
  {
    key: "lore-trials",
    number: 2,
    title: "Lore Trials",
    image: dashboardAsset("10_comic_book_library_panel.png"),
    imagePosition: "center 35%",
    fallbackClass: "quest-art-lore",
    description: "Test your knowledge and unlock memory fragments.",
    stats: [
      { label: "Quiz", value: "12" },
      { label: "Trials", value: "4 Available", accent: "blue" },
    ],
    cta: "Take Trial",
  },
  {
    key: "relic-discovery",
    number: 3,
    title: "Relic Discovery",
    image: dashboardAsset("04_artisan_forge_card.png"),
    imagePosition: "center 40%",
    fallbackClass: "quest-art-relic",
    description: "Choose artifacts and uncover hidden story outcomes.",
    stats: [
      { label: "Relics Found", value: "8 / 24" },
      { label: "Rarity", value: "Epic", accent: "purple" },
    ],
    cta: "Explore Relics",
  },
  {
    key: "faction-path",
    number: 4,
    title: "Faction Path",
    image: dashboardAsset("06_oshar_overview_map_style.png"),
    imagePosition: "center 45%",
    fallbackClass: "quest-art-faction",
    description: "Discover who you are in Treydora.",
    tags: ["Relic Hunter", "Shadow Diplomat", "Warborn Defender"],
    cta: "Discover Path",
  },
];

export const QUEST_DASHBOARD_RIGHT_RAIL = {
  questStatus: {
    rank: "Founder Level 7",
    xp: "12,400 / 15,000 XP",
    dailyStreak: "7 Days",
    questXp: "24,975 XP",
    achievementsCta: "View Achievements",
  },
  activeQuest: {
    title: "Oracle Story in Progress",
    loreFragments: "18 / 40",
    factionStatus: "Undecided",
  },
  activity: [
    { text: "New daily quest available.", ago: "2m ago" },
    { text: "Memory fragment unlocked: “The Fall of Atheris.”", ago: "1h ago" },
    { text: "Faction trial completed. +150 XP earned.", ago: "3h ago" },
    { text: "Oracle story path saved.", ago: "4h ago" },
    { text: "Relic discovered: Astral Lens.", ago: "5h ago" },
  ],
};
